import { Route } from '@src/Application/Types/ComponentTypes'

type Tab = {
    id: string
    label: string
    value: string
}

export const getTab = (routes: Route[]): Tab[] => {
    const tabs: Tab[] = []
    routes.forEach((route) => {
        const hasTab = tabs.some((tab) => tab.value === route.country)

        if (!hasTab) {
            tabs.push({
                label: route.country,
                value: route.country,
                id: route.country,
            })
        }

        return route
    })

    return tabs
}

export const handleTabChange =
    (setSelectedTab: (selectedTab: string) => void) =>
    (value: string): void => {
        setSelectedTab(value)
    }
